import { render, staticRenderFns } from "./Increment.vue?vue&type=template&id=456d0e86&scoped=true&"
import script from "./Increment.vue?vue&type=script&lang=js&"
export * from "./Increment.vue?vue&type=script&lang=js&"
import style0 from "./Increment.vue?vue&type=style&index=0&id=456d0e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d0e86",
  null
  
)

export default component.exports